import type {
  ICareerMainConnectedUsItem,
  ICareerMainConnectedUsLogoImage,
} from '~/domains/career/main/components/career-main-connectedUs/career-main-connectedUs.types'

export const MAIN_LOGO_ASSET: ICareerMainConnectedUsLogoImage = {
  srcDesktop: '/images/career/connectedUs/logo.svg',
  srcMobile: '/images/career/connectedUs/logo-mobile.svg',
  alt: 'career.connectedUs.logo.alt',
}

export const CONNECTED_US_ITEMS: ICareerMainConnectedUsItem[] = [
  {
    id: 'cooperation',
    title: 'career.connectedUs.values.cooperation.title',
    description: 'career.connectedUs.values.cooperation.description',
    image: {
      src: 'career.connectedUs.values.cooperation.src',
      alt: 'career.connectedUs.values.cooperation.alt',
    },
  },
  {
    id: 'responsibility',
    title: 'career.connectedUs.values.responsibility.title',
    description: 'career.connectedUs.values.responsibility.description',
    image: {
      src: 'career.connectedUs.values.responsibility.src',
      alt: 'career.connectedUs.values.responsibility.alt',
    },
  },
  {
    id: 'development',
    title: 'career.connectedUs.values.development.title',
    description: 'career.connectedUs.values.development.description',
    image: {
      src: 'career.connectedUs.values.development.src',
      alt: 'career.connectedUs.values.development.alt',
    },
  },
  {
    id: 'agency',
    title: 'career.connectedUs.values.agency.title',
    description: 'career.connectedUs.values.agency.description',
    image: {
      src: 'career.connectedUs.values.agency.src',
      alt: 'career.connectedUs.values.agency.alt',
    },
  },
  {
    id: 'respect',
    title: 'career.connectedUs.values.respect.title',
    description: 'career.connectedUs.values.respect.description',
    image: {
      src: 'career.connectedUs.values.respect.src',
      alt: 'career.connectedUs.values.respect.alt',
    },
  },
]

